/**
 * Export `BlockImage` type.
 */

export type BlocksImages = {
  description?: string;
  image1: string;
  image2: string;
  image3: string;
  subtitle?: string;
  title?: string;
};

/**
 * Export `BlockImages` type.
 */

export type BlockImages = {
  blocks: BlocksImages[];
  slug: string;
};

/**
 * Export `BlockTranslations` type.
 */

export type BlockTranslations = {
  [key: string]: {
    description: string;
    subtitle?: string;
    title: string;
  };
};

/**
 * Export `blockImages`.
 */

export const blockImages = {
  alcoutim: [
    {
      image1: '/images/episodes/alcoutim/best-of-image-3-1.jpg',
      image2: '/images/episodes/alcoutim/best-of-image-3-2.jpg',
      image3: '/images/episodes/alcoutim/best-of-image-3-3.jpg'
    },
    {
      image1: '/images/episodes/alcoutim/best-of-image-4-1.jpg',
      image2: '/images/episodes/alcoutim/best-of-image-4-2.jpg',
      image3: '/images/episodes/alcoutim/best-of-image-4-3.jpg'
    },
    {
      image1: '/images/episodes/alcoutim/best-of-image-5-1.jpg',
      image2: '/images/episodes/alcoutim/best-of-image-5-2.jpg',
      image3: '/images/episodes/alcoutim/best-of-image-5-3.jpg'
    }
  ],
  beja: [
    {
      image1: '/images/episodes/beja/best-of-image-3-1.jpg',
      image2: '/images/episodes/beja/best-of-image-3-2.jpg',
      image3: '/images/episodes/beja/best-of-image-3-3.jpg'
    },
    {
      image1: '/images/episodes/beja/best-of-image-4-1.jpg',
      image2: '/images/episodes/beja/best-of-image-4-2.jpg',
      image3: '/images/episodes/beja/best-of-image-4-3.jpg'
    },
    {
      image1: '/images/episodes/beja/best-of-image-5-1.jpg',
      image2: '/images/episodes/beja/best-of-image-5-2.jpg',
      image3: '/images/episodes/beja/best-of-image-5-3.jpg'
    }
  ],
  braganca: [
    {
      image1: '/images/episodes/braganca/best-of-image-3-1.jpg',
      image2: '/images/episodes/braganca/best-of-image-3-2.jpg',
      image3: '/images/episodes/braganca/best-of-image-3-3.jpg'
    },
    {
      image1: '/images/episodes/braganca/best-of-image-4-1.jpg',
      image2: '/images/episodes/braganca/best-of-image-4-2.jpg',
      image3: '/images/episodes/braganca/best-of-image-4-3.jpg'
    },
    {
      image1: '/images/episodes/braganca/best-of-image-5-1.jpg',
      image2: '/images/episodes/braganca/best-of-image-5-2.jpg',
      image3: '/images/episodes/braganca/best-of-image-5-3.jpg'
    }
  ],
  coimbra: [
    {
      image1: '/images/episodes/coimbra/best-of-image-3-1.jpg',
      image2: '/images/episodes/coimbra/best-of-image-3-2.jpg',
      image3: '/images/episodes/coimbra/best-of-image-3-3.jpg'
    },
    {
      image1: '/images/episodes/coimbra/best-of-image-4-1.jpg',
      image2: '/images/episodes/coimbra/best-of-image-4-2.jpg',
      image3: '/images/episodes/coimbra/best-of-image-4-3.jpg'
    },
    {
      image1: '/images/episodes/coimbra/best-of-image-5-1.jpg',
      image2: '/images/episodes/coimbra/best-of-image-5-2.jpg',
      image3: '/images/episodes/coimbra/best-of-image-5-3.jpg'
    }
  ],
  'evora-montemor-o-novo': [
    {
      image1: '/images/episodes/evora-montemor-o-novo/best-of-image-3-1.jpg',
      image2: '/images/episodes/evora-montemor-o-novo/best-of-image-3-2.jpg',
      image3: '/images/episodes/evora-montemor-o-novo/best-of-image-3-3.jpg'
    },
    {
      image1: '/images/episodes/evora-montemor-o-novo/best-of-image-4-1.jpg',
      image2: '/images/episodes/evora-montemor-o-novo/best-of-image-4-2.jpg',
      image3: '/images/episodes/evora-montemor-o-novo/best-of-image-4-3.jpg'
    },
    {
      image1: '/images/episodes/evora-montemor-o-novo/best-of-image-5-1.jpg',
      image2: '/images/episodes/evora-montemor-o-novo/best-of-image-5-2.jpg',
      image3: '/images/episodes/evora-montemor-o-novo/best-of-image-5-3.jpg'
    }
  ],
  'guarda-pinhel-cidadelhe': [
    {
      image1: '/images/episodes/guarda/best-of-image-3-1.jpg',
      image2: '/images/episodes/guarda/best-of-image-3-2.jpg',
      image3: '/images/episodes/guarda/best-of-image-3-3.jpg'
    },
    {
      image1: '/images/episodes/guarda/best-of-image-4-1.jpg',
      image2: '/images/episodes/guarda/best-of-image-4-2.jpg',
      image3: '/images/episodes/guarda/best-of-image-4-3.jpg'
    },
    {
      image1: '/images/episodes/guarda/best-of-image-5-1.jpg',
      image2: '/images/episodes/guarda/best-of-image-5-2.jpg',
      image3: '/images/episodes/guarda/best-of-image-5-3.jpg'
    }
  ],
  guimaraes: [
    {
      image1: '/images/episodes/guimaraes/best-of-image-3-1.jpg',
      image2: '/images/episodes/guimaraes/best-of-image-3-2.jpg',
      image3: '/images/episodes/guimaraes/best-of-image-3-3.jpg'
    },
    {
      image1: '/images/episodes/guimaraes/best-of-image-4-1.jpg',
      image2: '/images/episodes/guimaraes/best-of-image-4-2.jpg',
      image3: '/images/episodes/guimaraes/best-of-image-4-3.jpg'
    }
  ],
  lagos: [
    {
      image1: '/images/episodes/lagos/best-of-image-3-1.jpg',
      image2: '/images/episodes/lagos/best-of-image-3-2.jpg',
      image3: '/images/episodes/lagos/best-of-image-3-3.jpg'
    },
    {
      image1: '/images/episodes/lagos/best-of-image-4-1.jpg',
      image2: '/images/episodes/lagos/best-of-image-4-2.jpg',
      image3: '/images/episodes/lagos/best-of-image-4-3.jpg'
    },
    {
      image1: '/images/episodes/lagos/best-of-image-5-1.jpg',
      image2: '/images/episodes/lagos/best-of-image-5-2.jpg',
      image3: '/images/episodes/lagos/best-of-image-5-3.jpg'
    }
  ],
  'lisboa-sintra-cascais': [
    {
      image1: '/images/episodes/lisboa-sintra-cascais/best-of-image-3-1.jpg',
      image2: '/images/episodes/lisboa-sintra-cascais/best-of-image-3-2.jpg',
      image3: '/images/episodes/lisboa-sintra-cascais/best-of-image-3-3.jpg'
    },
    {
      image1: '/images/episodes/lisboa-sintra-cascais/best-of-image-4-1.jpg',
      image2: '/images/episodes/lisboa-sintra-cascais/best-of-image-4-2.jpg',
      image3: '/images/episodes/lisboa-sintra-cascais/best-of-image-4-3.jpg'
    },
    {
      image1: '/images/episodes/lisboa-sintra-cascais/best-of-image-5-1.jpg',
      image2: '/images/episodes/lisboa-sintra-cascais/best-of-image-5-2.jpg',
      image3: '/images/episodes/lisboa-sintra-cascais/best-of-image-5-3.jpg'
    }
  ],
  mafra: [
    {
      image1: '/images/episodes/mafra/best-of-image-3-1.jpg',
      image2: '/images/episodes/mafra/best-of-image-3-2.jpg',
      image3: '/images/episodes/mafra/best-of-image-3-3.jpg'
    },
    {
      image1: '/images/episodes/mafra/best-of-image-4-1.jpg',
      image2: '/images/episodes/mafra/best-of-image-4-2.jpg',
      image3: '/images/episodes/mafra/best-of-image-4-3.jpg'
    },
    {
      image1: '/images/episodes/mafra/best-of-image-5-1.jpg',
      image2: '/images/episodes/mafra/best-of-image-5-2.jpg',
      image3: '/images/episodes/mafra/best-of-image-5-3.jpg'
    }
  ],
  setubal: [
    {
      image1: '/images/episodes/setubal/best-of-image-3-1.jpg',
      image2: '/images/episodes/setubal/best-of-image-3-2.jpg',
      image3: '/images/episodes/setubal/best-of-image-3-3.jpg'
    },
    {
      image1: '/images/episodes/setubal/best-of-image-4-1.jpg',
      image2: '/images/episodes/setubal/best-of-image-4-2.jpg',
      image3: '/images/episodes/setubal/best-of-image-4-3.jpg'
    },
    {
      image1: '/images/episodes/setubal/best-of-image-5-1.jpg',
      image2: '/images/episodes/setubal/best-of-image-5-2.jpg',
      image3: '/images/episodes/setubal/best-of-image-5-3.jpg'
    }
  ],
  'tomar-constancia': [
    {
      image1: '/images/episodes/tomar/best-of-image-3-1.jpg',
      image2: '/images/episodes/tomar/best-of-image-3-2.jpg',
      image3: '/images/episodes/tomar/best-of-image-3-3.jpg'
    },
    {
      image1: '/images/episodes/tomar/best-of-image-4-1.jpg',
      image2: '/images/episodes/tomar/best-of-image-4-2.jpg',
      image3: '/images/episodes/tomar/best-of-image-4-3.jpg'
    },
    {
      image1: '/images/episodes/tomar/best-of-image-5-1.jpg',
      image2: '/images/episodes/tomar/best-of-image-5-2.jpg',
      image3: '/images/episodes/tomar/best-of-image-5-3.jpg'
    }
  ],
  'vila-real': [
    {
      image1: '/images/episodes/vila-real/best-of-image-3-1.jpg',
      image2: '/images/episodes/vila-real/best-of-image-3-2.jpg',
      image3: '/images/episodes/vila-real/best-of-image-3-3.jpg'
    },
    {
      image1: '/images/episodes/vila-real/best-of-image-4-1.jpg',
      image2: '/images/episodes/vila-real/best-of-image-4-2.jpg',
      image3: '/images/episodes/vila-real/best-of-image-4-3.jpg'
    }
  ]
};
